import PropTypes from "prop-types"
import React from "react"

import classNames from "classnames"
import GeoBreakdownHeadingLink from "../geo_breakdown_heading_link"

import {
  horizontalList,
  link,
  noMargin as noMarginStyle,
} from "./styles.module.scss"

const providerCountType = {
  dementia: "dementiaCareHomeCount",
  care_home: "careHomeCount",
  home_care: "homeCareCount",
}

const removeEmptyLocations = (locations, careServiceType) => {
  if (!careServiceType) return locations

  return locations.filter(
    (location) => location[providerCountType[careServiceType]] > 0,
  )
}

const GeoBreakdownList = ({
  data,
  geographicScale,
  districtType,
  noMargin,
  careServiceType,
  pageType,
}) => {
  const serviceType = pageType || careServiceType
  const locations = removeEmptyLocations(data, serviceType)

  return (
    <ul className={classNames(horizontalList, { [noMarginStyle]: noMargin })}>
      {locations.map((location, i) => (
        <li
          className={classNames(link)}
          // eslint-disable-next-line react/no-array-index-key
          key={`${location.name}${location.geographicScale}${location.districtType}-${i}`}
        >
          <GeoBreakdownHeadingLink
            geographicScale={location.geographicScale || geographicScale}
            locationName={location.name || location.locationName}
            districtType={location.districtType || districtType}
            careHomeCount={location.careHomeCount}
            homeCareCount={location.homeCareCount}
            dementiaCareHomeCount={location.dementiaCareHomeCount}
            careServiceType={careServiceType}
          />
        </li>
      ))}
    </ul>
  )
}

const locationType = {
  geographicScale: PropTypes.string,
  name: PropTypes.string,
  districtType: PropTypes.string,
  careHomeCount: PropTypes.number,
  homeCareCount: PropTypes.number,
}

GeoBreakdownList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(locationType)),
  geographicScale: PropTypes.string.isRequired,
  districtType: PropTypes.string,
  noMargin: PropTypes.bool,
  careServiceType: PropTypes.oneOf(["dementia"]),
  pageType: PropTypes.string,
}

GeoBreakdownList.defaultProps = {
  noMargin: false,
  districtType: undefined,
  data: [],
  careServiceType: undefined,
  pageType: undefined,
}

export default GeoBreakdownList
